'use client';
import { useIsDesktop } from '@/_hooks/useBreakpoint';
import React, { useMemo } from 'react';
import Header from '@/app/[locale]/(home)/_components/Header';
import UniversalHeader from '@/_components/Header';
import SeoPageTitle from '@/_components/SeoPageTitle';
import { Box, Container, Text } from '@chakra-ui/react';
import Breadcrumbs from '@/_components/Breadcrumbs';
import { useTranslations } from 'next-intl';
import { Link } from '@/i18n/navigation';

function DeliveryTerms() {
  const t = useTranslations();
  const isDesktop = useIsDesktop();

  const breadCrumbs = useMemo(
    () => [
      {
        title: t('home'),
        link: '/',
      },
      {
        title: t('delivery_and_payment_terms'),
      },
    ],
    [t]
  );

  return (
    <Box bg='background' minH={'dvh'}>
      <Box display={{ base: 'none', lg: 'block' }}>
        <Header />
      </Box>
      <Box display={{ base: 'block', lg: 'none' }}>
        <UniversalHeader backLink='/profile' title={t('delivery_and_payment_terms')} />
        <SeoPageTitle>{t('delivery_and_payment_terms')}</SeoPageTitle>
      </Box>

      <Container maxW={'1264px'} pb={16}>
        {isDesktop && <>
          <Breadcrumbs data={breadCrumbs} />
          <Text
            mt={3}
            mb={6}
            as={'h1'}
            fontWeight={700}
            fontSize={24}
            lineHeight={'28.8px'}
          >
            {t('delivery_and_payment_terms')}
          </Text>
        </>
        }

        <Box fontSize={{ base: 14, lg: 18 }} rounded={16} p={{ base: 4, lg: 6 }} pb={{ base: 6, lg: 10 }} bg={'white'} mt={3}>
          <Text mb={4} lineHeight={'150%'} fontWeight={500} color={'#383838'}>
            По всем интересующим Вас вопросам просим звонить на единый номер{' '}
            <Link href='tel:1089' style={{ color: '#2563EB', fontWeight: 600 }}>
              1089
            </Link>
            , где Вас обязательно проконсультирует наш Специалист. Вы можете
            написать нам в телеграм{' '}
            <Link
              href='tel:+998909332676'
              style={{ color: '#2563EB', fontWeight: 600 }}
            >
              +99890-933-26-76
            </Link>{' '}
            (@Yaponamama) и воспользоваться телеграм-ботом{' '}
            <Link
              href='http://t.me/yaponamamabot'
              target='_blank'
              style={{ color: '#2563EB', fontWeight: 600 }}
            >
              @yaponamamabot
            </Link>
            . Доставка в пределах города - 15.000 сум. За пределами города
            доставка осуществляется на расстоянии до 10 км при дополнительной
            оплате 25.000 сум.
          </Text>

          <Text fontSize={20} fontWeight={700} color={'#383838'} mb={2}>
            Способы оплаты услуг:
          </Text>
          <Box
            as='ul'
            pl={5}
            color={'#383838'}
            fontWeight={500}
            lineHeight={'30px'}
          >
            <Box as='li' listStyleType='disc'>
              Наличными денежными средствами (в национальной валюте сум);
            </Box>
            <Box as='li' listStyleType='disc'>
              Банковской платежной картой;
            </Box>
            <Box as='li' listStyleType='disc'>
              Посредством платежных систем PayMe, Click.
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default DeliveryTerms;
